import styled from 'styled-components';
import Button from 'js/components/common/Button';

export default styled(Button)`
  && {
    && {
      width: 200px;
      margin: 3rem auto 0;
      display: block;
      max-width: 100%;
    }
  }
`;
